import React, { useState, useEffect } from "react";
 
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import { updateIR, getAllUsersByRole, changeInvoiceStatus } from "../../actions";
import jwt from "jsonwebtoken";
 
const useStyles = makeStyles(dashboardStyle);
 
const TaxTeamModal = ({
  open,
  close,
  Invoice_Id,
  setSuccessMessage,
  setErrorMessage,
  setLoading,
  loading,
  newFormState,
  statusForpayload,
  setStatusForPayload
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    Invoice_Id: Invoice_Id,
    IRUser: "",
  });
  const [filterloginUser, setFilterLoginUser] = useState([]);
  const [userData, setUserData] = useState([]);
  const [Filter, setfilter] = useState([]);
 
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
 
  const getUsers = async () => {
    getAllUsersByRole("Tax Team", setUserData, setLoading);
  };
  useEffect(() => {
    getUsers();
  }, []);
 
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
 
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
      state:'SendToTaxTeamFromIP'
    }));
    setStatusForPayload(formState.state)
  };
  const submitHandler = (e) => {
    e.preventDefault();
        changeInvoiceStatus(
          // newFormState.rtbId,
            newFormState.invoice_Id,
          formState.state,
          "",
          "",
          "",
          "",
          "",
          newFormState.comments,
          newFormState.aditional_Comments,
          ""
        );
    updateIR(
      formState,
      newFormState,
      setSuccessMessage,
      setErrorMessage,
      setLoading,
      close,
      navigate
    );
  };
  return (
    <Dialog open={open} onClose={close} fullWidth>
      <form onSubmit={submitHandler}>
        <DialogTitle>
          <Typography>
            Tax Team<span className={classes.asterisk}>*</span>
          </Typography>
        </DialogTitle>
        <div></div>
        <DialogContent>
          {/* <Typography>
            Tax Team<span className={classes.asterisk}>*</span>
          </Typography> */}
 
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-name-label">Select Tax Team</InputLabel>
            <Select
              labelId="demo-simple-name-label"
              id="demo-simple-name"
              label="Select Tax Team"
              name="taxTeam"
              value={formState.taxTeam}
              onChange={changeHandler}
              MenuProps={MenuProps}
            >
              {!loading ? (
                userData.length > 0 ? (
                  userData
                    ?.filter((item) => {
                      return item.userId != user?.LoginId;
                    })
                    .map((item, index) => (
                      <MenuItem key={index} value={item.userId}>
                        {item.userName}
                      </MenuItem>
                    ))
                ) : (
                  <MenuItem disabled>Not Found</MenuItem>
                )
              ) : (
                <MenuItem>
                  <CircularProgress size={24} />
                </MenuItem>
              )}
            </Select>
          </FormControl>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={close}>
            Close
          </Button>
          <Button color="secondary" variant="contained" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
 
export default TaxTeamModal;